import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const faqCategoryService = {
    fetchAllWithoutPaginate: async (params = {}) => {
      const response = await axiosInstance.get('/faq-category', {
        params,
      })
      return response.data
    },
    fetchAll: async (params = {}) => {
      const response = await axiosInstance.get('/faq-category/paginate', {
        params,
      })
      return response.data
    },
    getById: async (id) => {
        const response = await axiosInstance.get('/faq-category/' + id)
        return response.data
    },
    store: async (data) => {
        const response = await axiosInstance.post('/faq-category', data)
        return response.data
    },
    update: async (data) => {
        const response = await axiosInstance.put(`/faq-category/${data.id}`, data)
        return response.data
    },
    delete: async (id) => {
        const response = await axiosInstance.delete(`/faq-category/${id}`)
        return response.data
    },
}